import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  loadingSports: false,
  loadingLeagues: false,
  loadingEvents: false,
  loadingMarkets: false,
  loadingEventPricekinetic: false,
  loadingChangeOrderLeague: false,
  loadingStats: false,
  sportStats: {},
});

export default {
  namespaced: true,

  state: initState(),

  mutations: {
    LOAD_SPORT_LIST: (s, data) => (s.loadingSports = data),
    LOAD_LEAGUE_LIST: (s, data) => (s.loadingLeagues = data),
    LOAD_EVENT_LIST: (s, data) => (s.loadingEvents = data),
    LOAD_MARKET_LIST: (s, data) => (s.loadingMarkets = data),
    LOAD_LIST_EVENT_PRICEKINETIC: (s, data) =>
      (s.loadingEventPricekinetic = data),
    LOAD_CHANGE_ORDER_LEAGUE: (s, data) => (s.loadingChangeOrderLeague = data),
    LOAD_SPORT_STATS: (s, data) => (s.loadingStats = data),
    SET_SPORT_STATS: (s, data) => (s.sportStats = data),
  },

  actions: {
    async getListSport({ commit }, params) {
      commit("LOAD_SPORT_LIST", true);
      try {
        const res = await this.$api.get("/v1/portal/sports", { params });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_SPORT_LIST", false);
      }
    },
    async getListLeagueOfSport({ commit }, params) {
      commit("LOAD_LEAGUE_LIST", true);

      const { sportId, ...restParams } = params;
      try {
        const res = await this.$api.get(
          `/v1/portal/sports/${sportId}/leagues`,
          { params: restParams }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LEAGUE_LIST", false);
      }
    },
    async getListEventOfLeague({ commit }, params) {
      commit("LOAD_EVENT_LIST", true);
      try {
        console.log(params.eventId);
        const res = await this.$api.get("/v1/portal/sport-events", {
          params: {
            ...params,
            ...(params.eventId && { eventId: btoa(params.eventId) }),
          
        } });
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_EVENT_LIST", false);
      }
    },
    async getListMarketOfEvent({ commit }, params) {
      commit("LOAD_MARKET_LIST", true);
      try {
        const { eventId, ...restParams } = params;
        const res = await this.$api.get(
          `/v1/portal/sport-events/${btoa(eventId)}/markets`,
          { params: restParams }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_MARKET_LIST", false);
      }
    },
    async getListMarketOfEventEncode({ commit }, params) {
      commit("LOAD_MARKET_LIST", true);
      try {
        const { eventId, ...restParams } = params;
        const res = await this.$api.get(
          `/v1/portal/sport-events/${eventId}/markets`,
          { params: restParams }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_MARKET_LIST", false);
      }
    },
    async getListEventPricekinetic({ commit }, params) {
      commit("LOAD_LIST_EVENT_PRICEKINETIC", true);
      try {
        const { sportCode, ...rest } = params;
        const res = await this.$api.get(
          `/v1/portal/sport-events/${sportCode}/events`,
          { params: rest }
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_LIST_EVENT_PRICEKINETIC", false);
      }
    },
    async changeOrderNumberLeague({ commit }, params) {
      commit("LOAD_CHANGE_ORDER_LEAGUE", true);
      try {
        const res = await this.$api.put(
          "/v1/portal/sports/leagues/order-number",
          params
        );
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_CHANGE_ORDER_LEAGUE", false);
      }
    },
    async getSportStats({ commit }, params) {
      commit("LOAD_SPORT_STATS", true);
      try {
        const { data: res } = await this.$api.get(
          "/v1/portal/sports/stats/report",
          {
            params,
          }
        );
        commit("SET_SPORT_STATS", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_SPORT_STATS", false);
      }
    },
  },
};
